import styled from "styled-components";

import { ProfileNavigationStyledProps as Props } from "./ProfileNavigation.types";
import CONSTANTS from "config/constants";

const { BREAKPOINTS } = CONSTANTS;
const { tablet } = BREAKPOINTS;

const ProfileNavigationStyled = styled.div<Props>`
  display: flex;
  flex-direction: column;
  height: max-content;
  border: 0.1rem solid var(--palette-gray-s0-l95);
  border-radius: 0.8rem;
  background-color: var(--palette-white);

  .ProfileNavigation {
    &__preview {
      border-radius: 0.8rem;
    }

    &__tab {
      display: flex;
      gap: 2rem;
      align-items: center;
      padding: 1.6rem;
      background: transparent;
      text-decoration: none;

      @media (max-width: ${tablet}px) {
        padding: 1.6rem 1.2rem;
      }

      &.is-currently-active {
        background: var(--palette-black-h60-s25-l2-a10);

        path {
          fill: var(--palette-white);
        }
      }
    }

    &__tab-icon {
      path {
        fill: var(--palette-black-s0-l10);
      }
    }

    &__tab-name {
      font-size: 1.6rem;
      font-weight: 600;

      &--active {
        color: var(--palette-white);
      }
    }

    &__logout-button {
      display: flex;
      padding-left: 0.8rem;
      font-family: inherit;
      font-size: 1.6rem;
      font-weight: 600;
      border: none;
      background: transparent;
      cursor: pointer;
      padding: 1.6rem;

      @media (max-width: ${tablet}px) {
        padding: 1.6rem 0;
        padding-left: 1.2rem;
      }
    }
  }
`;

export default ProfileNavigationStyled;
